document.addEventListener('DOMContentLoaded', function() {
  const swiper = new Swiper('.media-gallery', {
    loop: true,

  //  navigation: {
  //     nextEl: "#media-gallery__next-btn",
  //     prevEl: "#media-gallery__prev-btn"
  //   },

    pagination: {
      el: '.swiper-pagination',
      clickable: true,
    }
  });
});